<div class="edit-hero">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <button class="btn btn-back" (click)="goBack()">
                    <i class="bi bi-arrow-left-circle-fill"></i>
                    <span>Back to Mating Rules</span>
                </button>
            </div>
            <div class="col-md-6 text-end">
                <button type="button" class="btn btn-hero-action" (click)="showCrossSectionInformation()">
                    <i class="bi bi-plus-circle-fill"></i>
                    <span>Add Cross Section</span>
                </button>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <div class="hero-content">
                    <h1 class="hero-title">
                        <i class="bi bi-bezier2 hero-icon"></i>
                        Edit Mating Rule
                    </h1>
                    <p class="hero-subtitle">View and edit mating rule information, sections, and cross sections</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container edit-container">
        <!-- Loading indicator -->
        <div *ngIf="loading" class="loader-overlay">
            <div class="spinner-wrapper">
                <div class="spinner-border text-light" role="status"></div>
                <p class="loading-text">Loading rule details...</p>
            </div>
        </div>

        <!-- Rule Information -->
        <div class="row" *ngIf="!loading && rule">
            <!-- Rule Details Card -->
            <div class="col-md-12 mb-4">
                <div class="modern-info-card">
                    <div class="info-card-header">
                        <div class="header-content">
                            <i class="bi bi-info-circle-fill header-icon"></i>
                            <h5 class="header-title">Rule Information</h5>
                        </div>
                    </div>
                    <div class="info-card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <dl class="row">
                                    <dt class="col-sm-4">Rule ID:</dt>
                                    <dd class="col-sm-8">{{rule.id || 'N/A'}}</dd>

                                    <dt class="col-sm-4">Rule Name:</dt>
                                    <dd class="col-sm-8">{{rule.name || 'N/A'}}</dd>

                                    <dt class="col-sm-4">Rule Description:</dt>
                                    <dd class="col-sm-8">{{rule.description || 'N/A'}}</dd>

                                </dl>
                            </div>
                            <div class="col-md-6">
                                <dl class="row">
                                    <dt class="col-sm-4">Created At:</dt>
                                    <dd class="col-sm-8">
                                        <span *ngIf="rule.createdAt">{{rule.createdAt | date:'short'}}</span>
                                        <span *ngIf="!rule.createdAt">N/A</span>
                                    </dd>

                                    <dt class="col-sm-4">Updated At:</dt>
                                    <dd class="col-sm-8">
                                        <span *ngIf="rule.updatedAt">{{rule.updatedAt | date:'short'}}</span>
                                        <span *ngIf="!rule.updatedAt">N/A</span>
                                    </dd>

                                    <dt class="col-sm-4">Cross Sections Count:</dt>
                                    <dd class="col-sm-8">
                                        <span class="modern-badge badge-primary">{{rule.crossSections?.length || 0}}</span>
                                    </dd>


                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Sections Card -->
            <div class="col-md-12 mb-4" *ngIf="rule.crossSections && rule.crossSections.length > 0">
                <div class="modern-sections-card">
                    <div class="sections-card-header">
                        <div class="header-content">
                            <i class="bi bi-diagram-3-fill header-icon"></i>
                            <h5 class="header-title">Cross Sections</h5>
                        </div>
                        <span class="section-count-badge">{{rule.crossSections.length}}</span>
                    </div>
                    <div class="sections-card-body">
                        <div class="accordion" id="sectionsAccordion">
                            <div class="accordion-item"
                                *ngFor="let section of rule.crossSections; let i = index; trackBy: trackBySectionId">
                                <!-- <h2 class="accordion-header" [id]="'heading' + i">
                                <button class="accordion-button" type="button" [attr.data-bs-toggle]="'collapse'"
                                    [attr.data-bs-target]="'#collapse' + i" [attr.aria-expanded]="i === 0"
                                    [attr.aria-controls]="'collapse' + i">
                                    <i class="bi bi-box-seam me-2"></i>
                                    <strong>{{section.id || 'Section ' + (i + 1)}}</strong>
                                    <span class="badge bg-info ms-2" *ngIf="section.description">
                                        {{section.description}}
                                    </span>
                                    <span class="badge bg-success ms-2" *ngIf="hasCrossSections(section)">
                                        {{rule.crossSections?.length || 0}} Cross Sections
                                    </span>
                                </button>
                            </h2> -->
                                <div [id]="'collapse' + i" class="accordion-collapse collapse" [class.show]="i === 0"
                                    [attr.aria-labelledby]="'heading' + i" data-bs-parent="#sectionsAccordion">
                                    <div class="accordion-body">
                                        <!-- Section Details -->
                                        <!-- <div class="row mb-3">
                                        <div class="col-md-6">
                                            <dl class="row">
                                                <dt class="col-sm-5">Section ID:</dt>
                                                <dd class="col-sm-7">{{section.id || 'N/A'}}

                                                            </dd>

                                                <dt class="col-sm-5">Description:</dt>
                                                <dd class="col-sm-7">{{section.description || 'N/A'}}</dd>
                                            </dl>
                                        </div>
                                        <div class="col-md-6">
                                            <dl class="row">
                                                <dt class="col-sm-5">Section ID (Internal):</dt>
                                                <dd class="col-sm-7">{{section.id || 'N/A'}}</dd>

                                                <dt class="col-sm-5">Image URL:</dt>
                                                <dd class="col-sm-7">
                                                    <a *ngIf="section.imageUrl" [href]="section.imageUrl" target="_blank"
                                                        class="text-primary">
                                                        {{section.imageUrl}}
                                                    </a>
                                                    <span *ngIf="!section.imageUrl">N/A</span>
                                                </dd>
                                            </dl>
                                        </div>
                                    </div> -->

                                        <!-- Cross Sections -->
                                        <div *ngIf="hasCrossSections(rule)">
                                            <h6 class="section-subtitle">
                                                <i class="bi bi-layers-fill"></i> Cross Sections
                                            </h6>
                                            <div class="modern-table-wrapper">
                                                <table class="modern-edit-table">
                                                    <thead>
                                                        <tr>
                                                            <th (click)="onSort('id')" class="sortable-header">
                                                                <i class="bi sort-icon" [ngClass]="getSortIcon('id')"></i>
                                                                ID
                                                            </th>
                                                            <th (click)="onSort('description')" class="sortable-header">
                                                                <i class="bi sort-icon" [ngClass]="getSortIcon('description')"></i>
                                                                Description
                                                            </th>
                                                            <th (click)="onSort('material')" class="sortable-header" style="min-width: 150px;">
                                                                <i class="bi sort-icon" [ngClass]="getSortIcon('material')"></i>
                                                                Material
                                                            </th>
                                                            <th (click)="onSort('type')" class="sortable-header" style="min-width: 150px;">
                                                                <i class="bi sort-icon" [ngClass]="getSortIcon('type')"></i>
                                                                Type
                                                            </th>
                                                            <th>Article IDs</th>
                                                            <th>Transformation</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            *ngFor="let crossSection of rule.crossSections; trackBy: trackByCrossSectionId">
                                                            <td class="id-cell">{{crossSection.id || 'N/A'}}</td>
                                                            <td>
                                                                <input
                                                                    *ngIf="editingField === crossSection.id + '-description'"
                                                                    type="text" class="form-control form-control-sm"
                                                                    [(ngModel)]="crossSection.description"
                                                                    (blur)="stopEditing(crossSection)" autofocus />

                                                                <span
                                                                    *ngIf="editingField !== crossSection.id + '-description'"
                                                                    (click)="startEditing(crossSection, 'description')"
                                                                    class="editable-text">
                                                                    {{ crossSection.description || 'N/A' }}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    *ngIf="editingField === crossSection.id + '-material'"
                                                                    type="text" class="form-control form-control-sm"
                                                                    [(ngModel)]="crossSection.material"
                                                                    (blur)="stopEditing(crossSection)" autofocus />
                                                                <span
                                                                    *ngIf="editingField !== crossSection.id + '-material'"
                                                                    (click)="startEditing(crossSection, 'material')"
                                                                    class="badge bg-secondary editable-text">
                                                                    {{ crossSection.material || 'N/A' }}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    *ngIf="editingField === crossSection.id + '-type'"
                                                                    type="text" class="form-control form-control-sm"
                                                                    [(ngModel)]="crossSection.type"
                                                                    (blur)="stopEditing(crossSection)" autofocus />
                                                                <span *ngIf="editingField !== crossSection.id + '-type'"
                                                                    (click)="startEditing(crossSection, 'type')"
                                                                    class="badge bg-info editable-text">
                                                                    {{ crossSection.type || 'N/A' }}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <div class="d-flex align-items-center gap-2">
                                                                    <span *ngIf="crossSection?.articleIds?.length;else none">
                                                                        <span class="badge bg-primary me-1"
                                                                            *ngFor="let article of crossSection.articleIds">
                                                                            {{ article}}
                                                                        </span>
                                                                    </span>

                                                                    <ng-template #none>
                                                                        <span class="text-muted">None</span>
                                                                    </ng-template>
                                                                    <button class="btn-modern-action btn-action-secondary"
                                                                        *ngIf="crossSection.articleIds"
                                                                        (click)="showArticleInformation(crossSection)">
                                                                        <i class="bi bi-pencil-fill"></i>
                                                                    </button>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <button class="btn-modern-action btn-action-secondary"
                                                                    *ngIf="crossSection.transformation"
                                                                    (click)="showTransformation(crossSection.transformation, crossSection)">
                                                                    <i class="bi bi-pencil-fill"></i>
                                                                </button>
                                                                <span *ngIf="!crossSection.transformation">N/A</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div *ngIf="!hasCrossSections(rule)" class="alert alert-info">
                                            <i class="bi bi-info-circle"></i> No cross sections available for this
                                            section.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- No Sections Message -->
            <div class="col-md-12" *ngIf="!rule.crossSections || rule.crossSections.length === 0">
                <div class="alert alert-warning">
                    <i class="bi bi-exclamation-triangle"></i> No sections available for this rule.
                </div>
            </div>
        </div>
    </div>

    <!-- Transformation Modal -->
    <div class="modal fade" [class.show]="showTransformationModal"
        [style.display]="showTransformationModal ? 'block' : 'none'" tabindex="-1" *ngIf="showTransformationModal">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header modern-modal-header">
                    <h5 class="modal-title">
                        <i class="bi bi-arrows-move me-2"></i>
                        Transformation Data
                    </h5>
                    <button type="button" class="btn-close btn-close-dark" (click)="closeTransformationModal()"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <!-- Position Section -->
                    <div class="transformation-section mb-3">
                        <h6 class="text-muted mb-2"><i class="bi bi-arrows-move me-2"></i> Position</h6>
                        <div class="row g-3">
                            <div class="col-md-4">
                                <label class="form-label"><i class="bi bi-arrow-left-right me-1"></i> X Axis *</label>
                                <input type="number" class="form-control modern-input" [(ngModel)]="positionX" 
                                    placeholder="0.0" step="0.01">
                            </div>
                            <div class="col-md-4">
                                <label class="form-label"><i class="bi bi-arrow-up-down me-1"></i> Y Axis *</label>
                                <input type="number" class="form-control modern-input" [(ngModel)]="positionY" 
                                    placeholder="0.0" step="0.01">
                            </div>
                            <div class="col-md-4">
                                <label class="form-label"><i class="bi bi-arrow-bar-up me-1"></i> Z Axis *</label>
                                <input type="number" class="form-control modern-input" [(ngModel)]="positionZ" 
                                    placeholder="0.0" step="0.01">
                            </div>
                        </div>
                    </div>

                    <!-- Scale & Rotation Section -->
                    <div class="transformation-section mt-3">
                        <h6 class="text-muted mb-2"><i class="bi bi-aspect-ratio me-2"></i> Scale & Rotation</h6>
                        <div class="row g-3">
                            <div class="col-md-4">
                                <label class="form-label"><i class="bi bi-arrows-expand me-1"></i> Scale X *</label>
                                <input type="number" class="form-control modern-input" [(ngModel)]="scaleX" 
                                    placeholder="1.0" step="0.01">
                            </div>
                            <div class="col-md-4">
                                <label class="form-label"><i class="bi bi-arrows-expand me-1"></i> Scale Y *</label>
                                <input type="number" class="form-control modern-input" [(ngModel)]="scaleY" 
                                    placeholder="1.0" step="0.01">
                            </div>
                            <div class="col-md-4">
                                <label class="form-label"><i class="bi bi-arrow-clockwise me-1"></i> Rotation (degrees) *</label>
                                <input type="number" class="form-control modern-input" [(ngModel)]="rotation" 
                                    placeholder="0" step="1">
                            </div>
                        </div>
                    </div>

                    <!-- Additional Data Section -->
                    <div class="article-section mt-3">
                        <h6 class="text-muted mb-2"><i class="bi bi-info-circle me-2"></i> Additional Data</h6>
                        <div class="row g-3">
                            <div class="col-md-8">
                                <label class="form-label"><i class="bi bi-image me-1"></i> Image URL</label>
                                <input type="url" class="form-control modern-input" [(ngModel)]="imageUrl" 
                                    placeholder="https://...">
                            </div>
                            <div class="col-md-4">
                                <label class="form-label"><i class="bi bi-symmetry-vertical me-1"></i> Mirrored</label>
                                <div class="form-check form-switch mt-2">
                                    <input class="form-check-input" type="checkbox" [(ngModel)]="isMirrored" 
                                        id="mirrorCheck">
                                    <label class="form-check-label" for="mirrorCheck">
                                        {{ isMirrored ? 'Yes' : 'No' }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="closeTransformationModal()">
                        <i class="bi bi-x-circle me-1"></i>
                        Cancel
                    </button>
                    <button type="button" class="btn btn-primary" (click)="saveRule()">
                        <i class="bi bi-check-circle me-1"></i>
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal backdrop -->
    <div class="modal-backdrop fade" [class.show]="showTransformationModal" *ngIf="showTransformationModal"></div>

    
    



    <!-- Article Modal -->
    <div class="modal fade" [class.show]="showArticleModal" [style.display]="showArticleModal ? 'block' : 'none'"
        tabindex="-1" *ngIf="showArticleModal">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header modern-modal-header">
                    <h5 class="modal-title">
                        <i class="bi bi-journal-text me-2"></i>
                        Article Data
                    </h5>
                    <button type="button" class="btn-close btn-close-dark" (click)="closeArticleModal()" 
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <!-- Article Section -->
                    <div class="article-section">
                        <!-- Header row: Title + Add Button -->
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h6 class="text-muted mb-0"><i class="bi bi-list-ul me-2"></i> Articles</h6>
                            <button class="btn-modern-action btn-action-primary" (click)="addArticle()">
                                <i class="bi bi-plus-circle me-1"></i>
                                Add Article
                            </button>
                        </div>

                        <!-- No Articles Message -->
                        <div *ngIf="articles.length === 0 && !isAddingArticle" class="alert alert-info mb-0">
                            <i class="bi bi-info-circle me-2"></i>
                            No articles added. Click <strong>Add Article</strong> to get started.
                        </div>

                        <div class="modern-table-wrapper" *ngIf="articles.length > 0 || isAddingArticle">
                            <table class="modern-edit-table">
                                <thead>
                                    <tr>
                                        <th><i class="bi bi-hash me-1"></i> Article ID</th>
                                        <th><i class="bi bi-tag me-1"></i> Article Name</th>
                                        <th><i class="bi bi-palette me-1"></i> Material</th>
                                        <th><i class="bi bi-diagram-3 me-1"></i> Type</th>
                                        <th style="width: 80px;"><i class="bi bi-gear"></i></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <!-- Add Article Row -->
                                    <tr *ngIf="isAddingArticle" class="adding-row">
                                        <td><span class="badge bg-success">New</span></td>
                                        <td>
                                            <input type="text" [(ngModel)]="newArticle.articleName" 
                                                class="form-control modern-input" placeholder="Enter article name" />
                                        </td>
                                        <td>
                                            <input type="text" [(ngModel)]="newArticle.material" 
                                                class="form-control modern-input" placeholder="Enter material" />
                                        </td>
                                        <td>
                                            <input type="text" [(ngModel)]="newArticle.type" 
                                                class="form-control modern-input" placeholder="Enter type" />
                                        </td>
                                        <td>
                                            <button class="btn btn-sm btn-success me-1" (click)="saveNewArticle()" 
                                                title="Save">
                                                <i class="bi bi-check-lg"></i>
                                            </button>
                                                <button class="btn btn-sm btn-secondary"
                                                (click)="cancelAddArticle()" title="Cancel">
                                                <i class="bi bi-x-lg"></i>
                                            </button>
                                    </td>
                                </tr>

                                    <!-- Existing Articles -->
                                    <tr *ngFor="let art of articles; let i = index">
                                        <td>{{ art.id }}</td>

                                        <!-- Article Name -->
                                        <td>
                                            <input *ngIf="editingField === 'art-' + i + '-articleName'" type="text"
                                                class="form-control modern-input" [(ngModel)]="art.articleName"
                                            (blur)="stopEditingArticle(i, 'articleName')" autofocus />
                                        <span *ngIf="editingField !== 'art-' + i + '-articleName'"
                                            (click)="startEditingArticle(i, 'articleName')" class="editable-text">
                                            {{ art.articleName || 'N/A' }}
                                        </span>
                                    </td>

                                    <!-- Material -->
                                    <td>
                                        <input *ngIf="editingField === 'art-' + i + '-material'" type="text"
                                            class="form-control modern-input" [(ngModel)]="art.material"
                                            (blur)="stopEditingArticle(i, 'material')" autofocus />
                                        <span *ngIf="editingField !== 'art-' + i + '-material'"
                                            (click)="startEditingArticle(i, 'material')" class="editable-text">
                                            {{ art.material || 'N/A' }}
                                        </span>
                                    </td>

                                    <!-- Type -->
                                    <td>
                                        <input *ngIf="editingField === 'art-' + i + '-type'" type="text"
                                                class="form-control modern-input" [(ngModel)]="art.type"
                                                (blur)="stopEditingArticle(i, 'type')" autofocus />
                                            <span *ngIf="editingField !== 'art-' + i + '-type'"
                                                (click)="startEditingArticle(i, 'type')" class="editable-text">
                                                {{ art.type || 'N/A' }}
                                            </span>
                                        </td>

                                        <td>
                                            <button type="button" class="btn btn-sm btn-danger"
                                                (click)="removeArticle(i)" title="Remove Article">
                                                <i class="bi bi-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="closeArticleModal()">
                        <i class="bi bi-x-circle me-1"></i>
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal backdrop -->
    <div class="modal-backdrop fade" [class.show]="showArticleModal" *ngIf="showArticleModal"></div>


    <!-- Cross Section Modal -->
    <div class="modal fade" [class.show]="showCrossSectionModal"
        [style.display]="showCrossSectionModal ? 'block' : 'none'" tabindex="-1" *ngIf="showCrossSectionModal">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Cross Sections</h5>
                    <button type="button" class="btn-close" (click)="closeCrossSectionModal()"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">


                    <!-- Article Data Section -->
                    <!-- <h5>Cross Sections</h5> -->



                    <div *ngIf="currentCrossSection">
                        <div class="section-item mb-2 p-2 border rounded bg-light">
                            <!-- <div class="sub-card-header d-flex justify-content-between align-items-center">
                                <span class="badge bg-primary">Cross Section 1</span>
                                <small class="text-muted"><i class="bi bi-info-circle me-1"></i> Transformation & Article Data</small>
                            </div> -->
                            <div class="row g-3">
                                <div class="col-md-4">
                                    <label class="form-label"><i class="bi bi-card-text me-1"></i> Description *</label>
                                    <input type="text" class="form-control modern-input"
                                        [(ngModel)]="currentCrossSection!.description" placeholder="Section description"
                                        name="description">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label"><i class="bi bi-box me-1"></i> Material *</label>
                                    <input type="text" class="form-control modern-input" [(ngModel)]="currentCrossSection!.material"
                                        placeholder="e.g., Steel, Aluminum" name="material">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label"><i class="bi bi-tag me-1"></i> Type *</label>
                                    <input type="text" class="form-control modern-input" [(ngModel)]="currentCrossSection!.type"
                                        placeholder="Type" name="type">
                                </div>
                            </div>
                            <div class="transformation-section mt-3">
                                <h6 class="text-muted mb-2"><i class="bi bi-arrows-move me-2"></i> Position</h6>
                                <div class="row g-3">
                                    <div class="col-md-4">
                                        <label class="form-label"><i class="bi bi-arrow-left-right me-1"></i> X Axis *</label>
                                        <input type="number" class="form-control modern-input" [(ngModel)]="positionX" 
                                            placeholder="0.0" name="positionX">
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label"><i class="bi bi-arrow-up-down me-1"></i> Y Axis *</label>
                                        <input type="number" class="form-control modern-input" [(ngModel)]="positionY" 
                                            placeholder="0.0" name="positionY">
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label"><i class="bi bi-arrow-bar-up me-1"></i> Z Axis *</label>
                                        <input type="number" class="form-control modern-input" [(ngModel)]="positionZ" 
                                            placeholder="0.0" name="positionZ">
                                    </div>
                                </div>
                            </div>
                            <div class="transformation-section mt-3">
                                <h6 class="text-muted mb-2"><i class="bi bi-aspect-ratio me-2"></i> Scale & Rotation</h6>
                                <div class="row g-3">
                                    <div class="col-md-4">
                                        <label class="form-label"><i class="bi bi-arrows-expand me-1"></i> Scale X *</label>
                                        <input type="number" class="form-control modern-input" [(ngModel)]="scaleX" 
                                            placeholder="1.0" name="scaleX">
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label"><i class="bi bi-arrows-expand me-1"></i> Scale Y *</label>
                                        <input type="number" class="form-control modern-input" [(ngModel)]="scaleY" 
                                            placeholder="1.0" name="scaleY">
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label"><i class="bi bi-arrow-clockwise me-1"></i> Rotation (degrees) *</label>
                                        <input type="number" class="form-control modern-input" [(ngModel)]="rotation" 
                                            placeholder="0" name="rotation">
                                    </div>
                                </div>
                            </div>
                            <div class="article-section mt-3">
                                <h6 class="text-muted mb-2"><i class="bi bi-journal-text me-2"></i> Article Data</h6>
                                <div class="row g-3">
                                    <div class="col-md-5">
                                        <label class="form-label"><i class="bi bi-list-ul me-1"></i> Articles (JSON)</label>
                                        <input type="text" class="form-control modern-input" [(ngModel)]="articles"
                                            placeholder='[{"id":"ART-001","qty":2}]' name="articles">
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label"><i class="bi bi-image me-1"></i> Image URL</label>
                                        <input type="url" class="form-control modern-input" [(ngModel)]="imageUrl" 
                                            placeholder="https://..." name="imageUrl">
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label"><i class="bi bi-symmetry-vertical me-1"></i> Mirrored</label>
                                        <div class="form-check form-switch mt-2">
                                            <input class="form-check-input" type="checkbox" [(ngModel)]="isMirrored" 
                                                id="mirrorCheckCrossSection" name="isMirrored">
                                            <label class="form-check-label" for="mirrorCheckCrossSection">
                                                {{ isMirrored ? 'Yes' : 'No' }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" (click)="closeCrossSectionModal()">Cancel</button>
                    <button class="btn btn-primary" [disabled]="!isCrossSectionValid()"
                        (click)="saveCrossSection()">Save</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal backdrop -->
    <div class="modal-backdrop fade" [class.show]="showCrossSectionModal" *ngIf="showCrossSectionModal"></div>